// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  font-family: 'Roboto', sans-serif;
  background-color: #1799996e; /* Light gray background */
  color: #333; /* Dark gray text */
}

/* Increase specificity for MUI classes */
.App-header.MuiAppBar-root {
  padding: 20px !important;
}

.App-link {
  color: #F15A27; /* Orange for links */
}

/* Increase specificity for buttons */
.MuiButton-root.button {
  background-color: #000 !important; /* Black for buttons */
  color: #fafdfd !important; /* White text */
  border: 2px solid #cc4a20 !important; /* Red border */
  padding: 10px 20px !important;
  margin: 10px !important;
  cursor: pointer !important;
  border-radius: 4px !important;
  text-transform: uppercase !important;
  font-weight: bold !important;
}

.hero-background {
  background-color: #666;
  background-size: cover !important;
  background-position: center !important;
  min-height: 100vh;
  display: flex;
  align-items: center;
}

/* Logo in hero */
.hero-logo {
  display: block;
  margin: 0 auto 40px;  /* center & space below */
  width: 120px;         /* adjust as needed */
  height: auto;
}


.MuiButton-root.button:hover,
.MuiButton-root.button.active {
  background-color: #075a73 !important; /* Teal for hover and active */
}

.MuiPaper-root.card {
  background-color: #ffffff !important; /* White background for cards */
  border-radius: 8px !important;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1) !important;
  margin: 20px !important;
  padding: 20px !important;
}

.fieldset.MuiBox-root {
  border: 1px solid #ccc !important; /* Light gray border */
  border-radius: 4px !important;
  padding: 4px 8px !important;
  position: relative !important;
  margin-left: auto !important; /* Move to the far right */
}

.legend.MuiTypography-root {
  padding: 0 8px !important;
  color: #666 !important; /* Medium gray for legend */
}


.modal.MuiModal-root {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
}

.paper.MuiPaper-root {
  position: relative !important;
  padding: 16px !important;
  max-width: 500px !important;
  width: 90% !important;
  background-color: #ffffff !important; /* White background for modal content */
  color: #020102 !important;
}

.modal-close-button.MuiIconButton-root {
  position: absolute !important;
  right: 8px !important;
  top: 8px !important;
  color: #020102 !important;
}

/* Stepper and steps styling */
.stepper {
  background-color: #f5f5f5 !important; /* Match the background color */
}


.step-content {
  margin-top: 20px;
}


.list-item-text {
  color: #333 !important; /* Dark gray for list items */
}

.form-control {
  margin-bottom: 16px !important; /* Add margin bottom to form control */
}

.select {
  width: 100% !important; /* Ensure select fills width */
}

.menu-item {
  padding: 8px 16px !important; /* Add padding to menu items */
}

.typography {
  margin-bottom: 16px !important; /* Add margin bottom to typography */
}

.rule {
  padding: 8px 0 !important; /* Add padding to rule items */
  border-bottom: 1px solid #ccc !important; /* Add a bottom border to separate rules */
}

.button {
  margin-top: 16px !important; /* Add margin top to buttons */
}

.add-rule {
  margin-top: 16px !important; /* Add margin top to add rule section */
}

.text-field {
  margin-bottom: 16px !important; /* Add margin bottom to text fields */
}

/* Ensure that these classes are applied to MUI components specifically */
.MuiFormControl-root.form-control {
  margin-bottom: 16px !important;
}

.MuiSelect-root.select {
  width: 100% !important;
}

.MuiMenuItem-root.menu-item {
  padding: 8px 16px !important;
}

.MuiTypography-root.typography {
  margin-bottom: 16px !important;
}

.MuiButton-root.button {
  margin-top: 16px !important;
}

.MuiTextField-root.text-field {
  margin-bottom: 16px !important;
}

/* Stepper customizations */
.step-icon {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  border: 2px solid #cc4a20 !important; /* Red border */
  border-radius: 50% !important;
  width: 40px !important;
  height: 40px !important;
  background-color: #020102 !important; /* Black background */
}

.step-icon-active {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  border: 2px solid #046be2 !important; /* Red border */
  border-radius: 50% !important;
  width: 40px !important;
  height: 40px !important;
  background-color: #020102 !important; /* Black background */
}

.step-icon-completed {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  border: 2px solid #0be204b4 !important; /* Red border */
  border-radius: 50% !important;
  width: 40px !important;
  height: 40px !important;
  background-color: #020102 !important; /* Black background */
}

/* Step icon text style */
.step-number {
  font-size: 1.5rem !important; /* Bigger font size */
  font-weight: bold !important;
  color: #fafdfd !important; /* White for step number text */
  line-height: 40px !important; /* Center align text vertically */
  text-align: center !important; /* Center align text horizontally */
}

.step-progress {
  margin-top: 8px !important;
}

.step-label .MuiStepLabel-label {
  font-weight: 600 !important;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,iCAAiC;EACjC,2BAA2B,EAAE,0BAA0B;EACvD,WAAW,EAAE,mBAAmB;AAClC;;AAEA,yCAAyC;AACzC;EACE,wBAAwB;AAC1B;;AAEA;EACE,cAAc,EAAE,qBAAqB;AACvC;;AAEA,qCAAqC;AACrC;EACE,iCAAiC,EAAE,sBAAsB;EACzD,yBAAyB,EAAE,eAAe;EAC1C,oCAAoC,EAAE,eAAe;EACrD,6BAA6B;EAC7B,uBAAuB;EACvB,0BAA0B;EAC1B,6BAA6B;EAC7B,oCAAoC;EACpC,4BAA4B;AAC9B;;AAEA;EACE,sBAAsB;EACtB,iCAAiC;EACjC,sCAAsC;EACtC,iBAAiB;EACjB,aAAa;EACb,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;EACE,cAAc;EACd,mBAAmB,GAAG,yBAAyB;EAC/C,YAAY,UAAU,qBAAqB;EAC3C,YAAY;AACd;;;AAGA;;EAEE,oCAAoC,EAAE,8BAA8B;AACtE;;AAEA;EACE,oCAAoC,EAAE,+BAA+B;EACrE,6BAA6B;EAC7B,mDAAmD;EACnD,uBAAuB;EACvB,wBAAwB;AAC1B;;AAEA;EACE,iCAAiC,EAAE,sBAAsB;EACzD,6BAA6B;EAC7B,2BAA2B;EAC3B,6BAA6B;EAC7B,4BAA4B,EAAE,0BAA0B;AAC1D;;AAEA;EACE,yBAAyB;EACzB,sBAAsB,EAAE,2BAA2B;AACrD;;;AAGA;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,kCAAkC;AACpC;;AAEA;EACE,6BAA6B;EAC7B,wBAAwB;EACxB,2BAA2B;EAC3B,qBAAqB;EACrB,oCAAoC,EAAE,uCAAuC;EAC7E,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;EAC7B,qBAAqB;EACrB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA,8BAA8B;AAC9B;EACE,oCAAoC,EAAE,+BAA+B;AACvE;;;AAGA;EACE,gBAAgB;AAClB;;;AAGA;EACE,sBAAsB,EAAE,6BAA6B;AACvD;;AAEA;EACE,8BAA8B,EAAE,sCAAsC;AACxE;;AAEA;EACE,sBAAsB,EAAE,8BAA8B;AACxD;;AAEA;EACE,4BAA4B,EAAE,8BAA8B;AAC9D;;AAEA;EACE,8BAA8B,EAAE,oCAAoC;AACtE;;AAEA;EACE,yBAAyB,EAAE,8BAA8B;EACzD,wCAAwC,EAAE,0CAA0C;AACtF;;AAEA;EACE,2BAA2B,EAAE,8BAA8B;AAC7D;;AAEA;EACE,2BAA2B,EAAE,uCAAuC;AACtE;;AAEA;EACE,8BAA8B,EAAE,qCAAqC;AACvE;;AAEA,yEAAyE;AACzE;EACE,8BAA8B;AAChC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;AAChC;;AAEA,2BAA2B;AAC3B;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,kCAAkC;EAClC,oCAAoC,EAAE,eAAe;EACrD,6BAA6B;EAC7B,sBAAsB;EACtB,uBAAuB;EACvB,oCAAoC,EAAE,qBAAqB;AAC7D;;AAEA;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,kCAAkC;EAClC,oCAAoC,EAAE,eAAe;EACrD,6BAA6B;EAC7B,sBAAsB;EACtB,uBAAuB;EACvB,oCAAoC,EAAE,qBAAqB;AAC7D;;AAEA;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,kCAAkC;EAClC,sCAAsC,EAAE,eAAe;EACvD,6BAA6B;EAC7B,sBAAsB;EACtB,uBAAuB;EACvB,oCAAoC,EAAE,qBAAqB;AAC7D;;AAEA,yBAAyB;AACzB;EACE,4BAA4B,EAAE,qBAAqB;EACnD,4BAA4B;EAC5B,yBAAyB,EAAE,+BAA+B;EAC1D,4BAA4B,EAAE,iCAAiC;EAC/D,6BAA6B,EAAE,mCAAmC;AACpE;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;AAC7B","sourcesContent":["body {\n  margin: 0;\n  font-family: 'Roboto', sans-serif;\n  background-color: #1799996e; /* Light gray background */\n  color: #333; /* Dark gray text */\n}\n\n/* Increase specificity for MUI classes */\n.App-header.MuiAppBar-root {\n  padding: 20px !important;\n}\n\n.App-link {\n  color: #F15A27; /* Orange for links */\n}\n\n/* Increase specificity for buttons */\n.MuiButton-root.button {\n  background-color: #000 !important; /* Black for buttons */\n  color: #fafdfd !important; /* White text */\n  border: 2px solid #cc4a20 !important; /* Red border */\n  padding: 10px 20px !important;\n  margin: 10px !important;\n  cursor: pointer !important;\n  border-radius: 4px !important;\n  text-transform: uppercase !important;\n  font-weight: bold !important;\n}\n\n.hero-background {\n  background-color: #666;\n  background-size: cover !important;\n  background-position: center !important;\n  min-height: 100vh;\n  display: flex;\n  align-items: center;\n}\n\n/* Logo in hero */\n.hero-logo {\n  display: block;\n  margin: 0 auto 40px;  /* center & space below */\n  width: 120px;         /* adjust as needed */\n  height: auto;\n}\n\n\n.MuiButton-root.button:hover,\n.MuiButton-root.button.active {\n  background-color: #075a73 !important; /* Teal for hover and active */\n}\n\n.MuiPaper-root.card {\n  background-color: #ffffff !important; /* White background for cards */\n  border-radius: 8px !important;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1) !important;\n  margin: 20px !important;\n  padding: 20px !important;\n}\n\n.fieldset.MuiBox-root {\n  border: 1px solid #ccc !important; /* Light gray border */\n  border-radius: 4px !important;\n  padding: 4px 8px !important;\n  position: relative !important;\n  margin-left: auto !important; /* Move to the far right */\n}\n\n.legend.MuiTypography-root {\n  padding: 0 8px !important;\n  color: #666 !important; /* Medium gray for legend */\n}\n\n\n.modal.MuiModal-root {\n  display: flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n}\n\n.paper.MuiPaper-root {\n  position: relative !important;\n  padding: 16px !important;\n  max-width: 500px !important;\n  width: 90% !important;\n  background-color: #ffffff !important; /* White background for modal content */\n  color: #020102 !important;\n}\n\n.modal-close-button.MuiIconButton-root {\n  position: absolute !important;\n  right: 8px !important;\n  top: 8px !important;\n  color: #020102 !important;\n}\n\n/* Stepper and steps styling */\n.stepper {\n  background-color: #f5f5f5 !important; /* Match the background color */\n}\n\n\n.step-content {\n  margin-top: 20px;\n}\n\n\n.list-item-text {\n  color: #333 !important; /* Dark gray for list items */\n}\n\n.form-control {\n  margin-bottom: 16px !important; /* Add margin bottom to form control */\n}\n\n.select {\n  width: 100% !important; /* Ensure select fills width */\n}\n\n.menu-item {\n  padding: 8px 16px !important; /* Add padding to menu items */\n}\n\n.typography {\n  margin-bottom: 16px !important; /* Add margin bottom to typography */\n}\n\n.rule {\n  padding: 8px 0 !important; /* Add padding to rule items */\n  border-bottom: 1px solid #ccc !important; /* Add a bottom border to separate rules */\n}\n\n.button {\n  margin-top: 16px !important; /* Add margin top to buttons */\n}\n\n.add-rule {\n  margin-top: 16px !important; /* Add margin top to add rule section */\n}\n\n.text-field {\n  margin-bottom: 16px !important; /* Add margin bottom to text fields */\n}\n\n/* Ensure that these classes are applied to MUI components specifically */\n.MuiFormControl-root.form-control {\n  margin-bottom: 16px !important;\n}\n\n.MuiSelect-root.select {\n  width: 100% !important;\n}\n\n.MuiMenuItem-root.menu-item {\n  padding: 8px 16px !important;\n}\n\n.MuiTypography-root.typography {\n  margin-bottom: 16px !important;\n}\n\n.MuiButton-root.button {\n  margin-top: 16px !important;\n}\n\n.MuiTextField-root.text-field {\n  margin-bottom: 16px !important;\n}\n\n/* Stepper customizations */\n.step-icon {\n  display: flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n  border: 2px solid #cc4a20 !important; /* Red border */\n  border-radius: 50% !important;\n  width: 40px !important;\n  height: 40px !important;\n  background-color: #020102 !important; /* Black background */\n}\n\n.step-icon-active {\n  display: flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n  border: 2px solid #046be2 !important; /* Red border */\n  border-radius: 50% !important;\n  width: 40px !important;\n  height: 40px !important;\n  background-color: #020102 !important; /* Black background */\n}\n\n.step-icon-completed {\n  display: flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n  border: 2px solid #0be204b4 !important; /* Red border */\n  border-radius: 50% !important;\n  width: 40px !important;\n  height: 40px !important;\n  background-color: #020102 !important; /* Black background */\n}\n\n/* Step icon text style */\n.step-number {\n  font-size: 1.5rem !important; /* Bigger font size */\n  font-weight: bold !important;\n  color: #fafdfd !important; /* White for step number text */\n  line-height: 40px !important; /* Center align text vertically */\n  text-align: center !important; /* Center align text horizontally */\n}\n\n.step-progress {\n  margin-top: 8px !important;\n}\n\n.step-label .MuiStepLabel-label {\n  font-weight: 600 !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
